import {Component, input, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import { MessageService } from 'primeng/api';
import { BulkUpdateService } from '../../../../../../service/bulk-update.service';
import { BulkUpdateExecutionDetailModel } from '../../../../../../model/bulk-update-execution-detail.model';

@Component({
    selector: 'auto-bulk-update-execution-detail',
    templateUrl: './bulk-update-execution-detail.component.html',
    styleUrl: './bulk-update-execution-detail.component.scss',
    standalone: false
})
export class BulkUpdateExecutionDetailComponent implements OnInit, OnChanges {
  @Input() executionId: number | string | null = null;
  @Input() executionDescription: string | null = null;

  details: BulkUpdateExecutionDetailModel[] = [];
  loading = false;
  error: string | null = null;
  filterText: string = '';
  errorDialogVisible = false;
  errorDialogTitle = 'Error Details';
  errorDialogMessages: string[] = [];
  errorDialogSingleMessage: string | null = null;

  constructor(private bulkUpdateService: BulkUpdateService, private messageService: MessageService) {}

  ngOnInit(): void {
    if (this.executionId) {
      this.loadDetails();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['executionId'] && !changes['executionId'].firstChange) {
      this.loadDetails();
    }
  }

  private loadDetails(): void {
    if (this.executionId) {
      this.loading = true;
      this.error = null;
      this.bulkUpdateService.getBulkUpdateExecutionDetails(this.executionId).subscribe({
        next: (rows) => {
          // Add derived label for filtering/display convenience
          this.details = (rows || []).map((result) => ({
            ...result,
            accountLabel: (result.accountName ? `${result.accountName} (${result.accountId})` : `Account (${result.accountId})`)
          }));
          this.loading = false;
        },
        error: () => {
          this.messageService.add({severity: 'error', summary: 'Error', detail: 'Failed to load execution details'});
          this.error = null;
          this.details = [];
          this.loading = false;
        }
      });
    }
  }

  openErrorDialog(row: BulkUpdateExecutionDetailModel): void {
    const label = row.campaignAdGroupName || 'Error Details';
    this.errorDialogTitle = `Errors - ${label}`;

    const raw = row.errorMessage || '';
    const parts = raw
      .split(/;|\n/)
      .map((value) => value.trim())
      .filter((sValue) => sValue.length > 0);

    if (parts.length > 1) {
      this.errorDialogMessages = parts;
      this.errorDialogSingleMessage = null;
    } else if (parts.length === 1) {
      this.errorDialogMessages = [];
      this.errorDialogSingleMessage = parts[0];
    } else {
      this.errorDialogMessages = [];
      this.errorDialogSingleMessage = null;
    }

    this.errorDialogVisible = true;
  }

  public refreshDetails(): void {
    this.loadDetails();
  }
}
